module.exports = __webpack_public_path__ + "img/yalda_afsaka_no.1a978780.png";